import Modal from './Modal';
export { default as ActionModal } from './actionModal';
export { default as SecureModal } from './secureModal';
export { default as ConfirmModal } from './confirmModal';
export type { ConfirmModalProps } from './confirmModal';

export default Modal;
